import { useContext } from 'react';

import { LifeAreaFormContext } from './life-area-form-context';

export const useOpenCreateLifeAreaDialog = () => {
  const { onCreateLifeArea } = useContext(LifeAreaFormContext);

  return onCreateLifeArea;
};
